// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file editor_template.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file editor_template.proto.
 */
export const file_editor_template: GenFile = /*@__PURE__*/
  fileDesc("ChVlZGl0b3JfdGVtcGxhdGUucHJvdG8SC2dycGMuYXBpLnYxIqABCg5FZGl0b3JUZW1wbGF0ZRIKCgJpZBgBIAEoAxIMCgR0eXBlGAIgASgJEgwKBG5hbWUYAyABKAkSDgoGZGVzaWduGAQgASgJEhAKCGR0Q3JlYXRlGAYgASgDEhAKCGR0VXBkYXRlGAcgASgDEhEKCWlzRGVsZXRlZBgIIAEoCBIMCgRodG1sGAkgASgJEhEKCWlzRGVmYXVsdBgKIAEoCEIGWgQuO3BiYgZwcm90bzM");

/**
 * EditorTemplate
 *
 * @generated from message grpc.api.v1.EditorTemplate
 */
export type EditorTemplate = Message<"grpc.api.v1.EditorTemplate"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string design = 4;
   */
  design: string;

  /**
   * @generated from field: int64 dtCreate = 6;
   */
  dtCreate: bigint;

  /**
   * @generated from field: int64 dtUpdate = 7;
   */
  dtUpdate: bigint;

  /**
   * @generated from field: bool isDeleted = 8;
   */
  isDeleted: boolean;

  /**
   * @generated from field: string html = 9;
   */
  html: string;

  /**
   * @generated from field: bool isDefault = 10;
   */
  isDefault: boolean;
};

/**
 * Describes the message grpc.api.v1.EditorTemplate.
 * Use `create(EditorTemplateSchema)` to create a new message.
 */
export const EditorTemplateSchema: GenMessage<EditorTemplate> = /*@__PURE__*/
  messageDesc(file_editor_template, 0);

